import { Component, OnInit, Inject } from '@angular/core';
import { SystemAccountAuthModel } from '../../../../core/models/system-account';
import { Router } from '@angular/router';
import { IAuthService } from '../../../../core/services/api/contracts/auth-service';

@Component({
  selector: 'app-common-user',
  templateUrl: './common-user.component.html',
  styleUrls: ['./common-user.component.scss', "../index/index.component.css"]
})
export class CommonUserHomeComponent implements OnInit {
  public currentUser: SystemAccountAuthModel;

  constructor(private router: Router,
    @Inject("IAuthService") private authService: IAuthService) { }

  async ngOnInit() {
    this.currentUser = await this.authService.getCurrentProfile();
  }

  async logout() {
    await this.authService.logout();
    await this.router.navigate(["/"]);
  }

  loadUserInfo() {
    if (this.currentUser && this.currentUser.email) {
      var user = this.currentUser.organizations[0].name.toString();
  return `${user}`;
    } else {
      return "";
    }
  }


}
